import get from 'lodash/get';
import { AppState } from '../States';
import { AppTypes } from '../Types';
import { updateState } from '../Store';

export default function AppReducer(state = AppState, action) {
  switch (action.type) {
    case AppTypes.SET_ERROR:
      return { ...state, error: get(action, 'payload.error') };
    case AppTypes.SET_INFO:
      return { ...state, info: get(action, 'payload.info') };
    case AppTypes.SET_SUCCESS_MESSAGE:
      return { ...state, success: get(action, 'payload.success') };
    case AppTypes.RESET_ERROR:
      return { ...state, error: {} };
    case AppTypes.RESET_INFO:
      return { ...state, info: {} };
    case AppTypes.RESET_SUCCESS_MESSAGE:
      return { ...state, success: {} };
    case AppTypes.TOGGLE_MUTE:
      return (() => {
        const muted = !state.muted;
        window.eventemitter.emit('muteVideo', muted);
        return { ...state, muted };
      })();
    case AppTypes.DISABLE_VIDEO:
      return updateState(state, { videoEnabled: false });
    case AppTypes.IS_API_PROGRESS:
      return {
        ...state,
        isAPIProgress: action.payload,
      };
    case AppTypes.SET_SELECTED_RATING:
      return updateState(state, { appRating: action.payload });
    case AppTypes.RATING_SUCCESS:
      return updateState(state, { isRatingSuccess: true });
    case AppTypes.FEEDBACK_TYPES:
      return updateState(state, { feedbackTags: action.payload });
    case AppTypes.SET_FEEDBACK_STATUS:
      return updateState(state, { isRatingSuccess: action.payload });
    case AppTypes.SET_LANDING_PAGE_LANGUAGE:
      return {
        ...state,
        landingPageLanguage: action.payload,
      };
    default:
      return state;
  }
}
